export function getErrorResponseMessage(
  err: any,
  defaultMessage = 'Ocorreu um erro inesperado, tente novamente!',
): string {
  if (!err) return defaultMessage;

  if (err.response) {
    const { data } = err.response;

    if (data && typeof data === 'object') {
      if (data.message) return data.message;
      if (data.error) return data.error;
      if (data.errors && Array.isArray(data.errors)) {
        return data.errors.join(', ');
      }
      if (data.errors.messages && data.errors.messages.length > 0) {
        return data.errors.messages.join(', ');
      }
    }

    if (typeof data === 'string' && data.trim() !== '') {
      return data;
    }
  }

  if (err.message && typeof err.message === 'string') {
    return err.message;
  }

  return defaultMessage;
}
